import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { DispatchDrawer } from "./DispatchDrawer"
import { ChangeDispatchDrawer } from "./changeDispatch";
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
            <DispatchDrawer />
            <ChangeDispatchDrawer />
        </>
    )
}